import React, { useState } from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { telegramIcon } from "@core/icons";
import { useTranslation } from "react-i18next";

import Page from "../../page-layout";
import { PhoneInputForm } from "./components/PhoneInputForm";
import { OtpCodeInputForm } from "./components/OtpCodeInputForm";
import { TelegramAuthModal } from "./components/TelegramAuthModal";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { BackButton } from "../../../parhato2/src/entities";
import ToggleActiveModule from "../../../components/ToggleActiveModule";
import { VerificationDateType } from "./types";
import { useConfig } from "../../../providers/config";
import { AppLauncher } from "@capacitor/app-launcher";

const AuthParhato2: React.FC = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [isTelegramModalOpen, setIsTelegramModalOpen] = useState(false);
  const [verificationData, setVerificationData] = useState<VerificationDateType>({
    codeId: "",
    phoneNumber: "",
  });

  const handleOpenOfferta = async () => {
    await AppLauncher.openUrl({ url: config.offertaUrl! });
  };

  return (
    <Page>
      <Page.Header className="pt-[env(safe-area-inset-top)]">
        <MaxWidthContainer classList="flex items-center justify-between bg-white h-16 pl-2.5 relative">
          <BackButton
            onClickButton={isPhoneVerified ? () => setIsPhoneVerified(false) : undefined}
            buttonStyles="justify-self-start ml-0"
          />
          <div className="text-center absolute top-5 left-1/2 -translate-x-1/2">{t("Login")}</div>

          {config?.isToggleSwitchModuleEnabled && (
            <div className="right-2.5">
              <ToggleActiveModule isViewDescription={false} isViewPopover containerClassName="pr-2.5" />
            </div>
          )}
        </MaxWidthContainer>
      </Page.Header>
      <Page.Content scrollEvents>
        <MaxWidthContainer
          maxWidthBreakpoint={"Sm"}
          classList="md:h-full px-4 pt-10 flex-grow flex flex-col justify-center w-full"
        >
          {!isPhoneVerified ? (
            <div className="flex flex-col items-center w-full">
              <PhoneInputForm
                setIsPhoneVerified={() => setIsPhoneVerified(true)}
                setVerificationData={setVerificationData}
              />

              {config?.telegramAuth?.enabled && (
                <>
                  <div>{t("or")}</div>
                  <IonButton
                    fill="clear"
                    type="button"
                    expand="block"
                    onClick={() => setIsTelegramModalOpen(true)}
                    className="bg-[#0088cc] rounded-full text-white w-[330px] sm:w-[430px]"
                  >
                    <IonIcon icon={telegramIcon} className="mr-2" />
                    <span>{t("Login with Telegram")}</span>
                  </IonButton>
                </>
              )}
            </div>
          ) : (
            <OtpCodeInputForm verificationData={verificationData} setVerificationData={setVerificationData} />
          )}

          {!!config.offertaUrl && (
            <div className="mt-2.5 mx-auto text-sm text-gray-500">
              <span>{t("Registration agreement prefix")}</span>
              <span onClick={handleOpenOfferta} className="cursor-pointer underline font-bold pl-1">
                {t("offer_term")}
              </span>
            </div>
          )}
        </MaxWidthContainer>
        {config?.telegramAuth?.enabled && (
          <TelegramAuthModal isOpen={isTelegramModalOpen} onDismiss={() => setIsTelegramModalOpen(false)} />
        )}
      </Page.Content>
    </Page>
  );
};

export default AuthParhato2;
